import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import { adminApi } from "../../lib/api";
import { Label, TextInput, Section, Switch } from "../FormControls";

const Settings = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminApi.settings.get().then(setData); }, []);

  const set = (k, v) => setData((d) => ({ ...d, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const updated = await adminApi.settings.put(data);
      setData(updated);
      toast.success("Settings saved");
    } catch {
      toast.error("Save failed");
    } finally { setSaving(false); }
  };

  if (!data) return <div className="glass rounded-2xl h-32 animate-pulse" />;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cyan-300 mb-1">CMS</div>
          <h1 className="font-display text-3xl text-white font-medium">Settings</h1>
          <p className="text-slate-400 text-sm mt-1">Site metadata and theme toggles.</p>
        </div>
        <button onClick={save} disabled={saving} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 text-black text-sm font-medium disabled:opacity-70">
          {saving ? <><Loader2 size={14} className="animate-spin" /> Saving</> : <><Save size={14} /> Save</>}
        </button>
      </div>
      <Section title="Site metadata">
        <Label>Site title</Label>
        <TextInput value={data.site_title} onChange={(v) => set("site_title", v)} />
        <div className="mt-4"><Label>Description</Label>
          <TextInput value={data.site_description} onChange={(v) => set("site_description", v)} />
        </div>
      </Section>
      <Section title="Theme & visuals">
        <div className="grid sm:grid-cols-2 gap-3">
          <div><Label>Primary accent (hex)</Label><TextInput value={data.accent_primary} onChange={(v) => set("accent_primary", v)} /></div>
          <div><Label>Secondary accent (hex)</Label><TextInput value={data.accent_secondary} onChange={(v) => set("accent_secondary", v)} /></div>
        </div>
        <div className="mt-4 flex items-center gap-6">
          <Switch value={data.show_particles} onChange={(v) => set("show_particles", v)} label="Show particle background" />
          <Switch value={data.show_avatar} onChange={(v) => set("show_avatar", v)} label="Show hero avatar" />
        </div>
      </Section>
    </div>
  );
};

export default Settings;
